import styled, { css } from 'styled-components';
import ImageOnda from '../../../../assets/images/onda.svg';
import ImageOndaSmall from '../../../../assets/images/onda-small.svg';
import ImageWord from '../../../../assets/images/300-hours.png';
import ImageWordSmall from '../../../../assets/images/300-hours-small.png';

export const LandingContainer = styled.section`
	position: relative;
	width: 100%;
	background-image: linear-gradient(138deg, #000000 12%, #242323 106%);
	overflow-x: hidden;

	.word {
		position: relative;
		width: 102%;
		background-image: url(${ImageWordSmall});
		background-repeat: no-repeat;
		background-position: top;
		left: 0;
		overflow-x: hidden;
		background-size: contain;
		${props => props.theme.breakpoints.up('xs')} {
			top: 0px;
			height: 115px;
		}

		${props => props.theme.breakpoints.up('sm')} {
			background-image: url(${ImageWord});
			top: -50px;
			height: 150px;
		}
		${props => props.theme.breakpoints.up('md')} {
			background-image: url(${ImageWord});
			top: -50px;
			height: 300px;
		}
	}
`;

const Onda = css`
	position: absolute;
	background-size: cover;
	height: 300px;
	width: 100%;
	background-position: bottom;

	${props => props.theme.breakpoints.up('xs')} {
		background-image: url(${ImageOndaSmall});
	}

	${props => props.theme.breakpoints.up('sm')} {
		background-image: url(${ImageOnda});
	}
`;

export const OndaStart = styled.div`
	${Onda};

	${props => props.theme.breakpoints.up('xs')} {
		top: 71px;
		height: 540px;
	}

	${props => props.theme.breakpoints.up('sm')} {
		top: -56px;
		height: 300px;
	}
`;

export const OndaEnd = styled.div`
	${Onda};

	bottom: 0px;
	${props => props.theme.breakpoints.up('xs')} {
		display: none;
	}
	${props => props.theme.breakpoints.up('sm')} {
		display: block;
	}
`;

export const Img = styled.img`
	width: 102%;
	overflow-x: hidden;

	${props => props.theme.breakpoints.up('xs')} {
		width: 101%;
		display: ${props => (props.onlyMobile ? 'block' : 'none')};
	}
	${props => props.theme.breakpoints.up('sm')} {
		height: auto;
		display: ${props => (props.onlyMobile ? 'none' : 'block')};
	}
`;
